module.exports = __webpack_public_path__ + "img/employment-plus.63815f3b.png";